import React from 'react';
import styled from 'styled-components';
import Section from './ui/Section';
import Container from './ui/Container';
import SectionHeading from './ui/SectionHeading';
import { PlusIcon } from './ui/Icons';
import { faqItems } from '../data/faq';

const Layout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);
  gap: clamp(2rem, 5vw, 4rem);
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 0;
  }
`;

const List = styled.div`
  border-top: 1px solid var(--border);
`;

const Item = styled.details`
  border-bottom: 1px solid var(--border);

  summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    min-height: 64px;
    padding: 1rem 0;
    cursor: pointer;
    list-style: none;
    font-family: var(--font-display);
    font-size: 1.0625rem;
    font-weight: 600;
    color: var(--text-1);
  }

  summary::-webkit-details-marker {
    display: none;
  }

  summary svg {
    flex-shrink: 0;
    color: var(--accent);
    transition: transform 0.2s ease;
  }

  &[open] summary svg {
    transform: rotate(45deg);
  }

  p {
    padding: 0 2.5rem 1.5rem 0;
    color: var(--text-2);
  }
`;

const FAQ: React.FC = () => (
  <Section aria-labelledby="faq-title">
    <Container>
      <Layout>
        <SectionHeading
          id="faq-title"
          eyebrow="FAQ"
          title="Common questions"
          description="Straight answers to what business owners usually ask us first."
        />
        <List>
          {faqItems.map((item) => (
            <Item key={item.question}>
              <summary>
                {item.question}
                <PlusIcon />
              </summary>
              <p>{item.answer}</p>
            </Item>
          ))}
        </List>
      </Layout>
    </Container>
  </Section>
);

export default FAQ;
